import { Badge } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type TryBadgeProps = {
  featureId: string;
  /**
   * When set, Try is a real button (home composer chrome). Omit on skill
   * cards — those already wrap the whole card in a button, so a nested
   * button would be invalid HTML.
   */
  onClick?: () => void;
  "data-testid"?: string;
};

/**
 * Surface Radix Badge. On skill cards this is not interactive (the card
 * button opens the walkthrough). On the home composer, `onClick` turns it
 * into the control that opens the walkthrough.
 */
export function TryBadge({
  featureId,
  onClick,
  "data-testid": dataTestId,
}: TryBadgeProps) {
  const { t } = useTranslation("ui");
  const label = t("tryWalkthrough.badge");
  const testId = dataTestId ?? `ask-puntt-try-badge-${featureId}`;

  if (onClick == null) {
    return (
      <Badge
        size="1"
        variant="surface"
        color="blue"
        data-testid={testId}
        className="absolute right-2 top-2 z-10"
      >
        {label}
      </Badge>
    );
  }

  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={t(`tryWalkthrough.${featureId}.badgeAriaLabel`)}
      onClick={onClick}
      className="inline-flex shrink-0 cursor-pointer items-center rounded-full border-0 bg-transparent p-0"
    >
      <Badge size="1" variant="surface" color="blue">
        {label}
      </Badge>
    </button>
  );
}
